import React from 'react'

const WorkOfferIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.25 21C4.7 21 4.229 20.8043 3.837 20.413C3.44567 20.021 3.25 19.55 3.25 19V5C3.25 4.45 3.44567 3.979 3.837 3.587C4.229 3.19567 4.7 3 5.25 3H19.25C19.8 3 20.271 3.19567 20.663 3.587C21.0543 3.979 21.25 4.45 21.25 5V19C21.25 19.55 21.0543 20.021 20.663 20.413C20.271 20.8043 19.8 21 19.25 21H5.25ZM12.25 16C12.8833 16 13.4583 15.8167 13.975 15.45C14.4917 15.0833 14.85 14.6 15.05 14H19.25V5H5.25V14H9.45C9.65 14.6 10.0083 15.0833 10.525 15.45C11.0417 15.8167 11.6167 16 12.25 16ZM12.25 14L8.25 10L9.65 8.55L11.25 10.15V6H13.25V10.15L14.85 8.55L16.25 10L12.25 14Z"
        fill="#3249D7"
      />
    </svg>
  )
}

export default WorkOfferIcon

//url(#mask0_16_26514)
